module.exports = __webpack_public_path__ + "static/media/wasabi-round-trans.d7669fe5.png";